import React, { useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';

import Popup from '../MUI/UI/Popup';
import RestaurantRatingWidget from '../UI/RestaurantRatingWidget';
import RestaurantReviewsList from '../RestaurantReviews/RestaurantReviewsList';
// import DeliveryHours from '../DeliveryHours/DeliveryHours';
// import DeliveryFeesListCard from '../DeliveryFees/DeliveryFeesListCard';
import DeliveryHoursTable from '../DeliveryHours/DeliveryHoursTable';
import DeliveryFeesSimpleCard from '../DeliveryFees/DeliveryFeesSimpleCard';
import classes from '../CSS/SelectRestaurantCard.module.css';

const SelectRestaurantCard = (props) => {
  // console.log('##### SelectRestaurantCard #####');
  // console.log('props');
  // console.log(props);

  const { restaurant, selectRestaurant, userRole } = props;

  const {
    restaurantUuid,
    name,
    description,
    address,
    city,
    state,
    foodType,
    listImage,
    leagueExperience,
    rating,
    numberOfRatings,
    deliveryFees,
    deliveryHours,
    orderLeadTime,
  } = restaurant;

  const displayAddress = userRole === 'User' ? city + ', ' + state : address + ', ' + city + ', ' + state;

  const [openPopupReviews, setOpenPopupReviews] = useState(false);

  const displayOrderLeadTime = true;

  const showRestaurantReviewssHandler = () => {
    setOpenPopupReviews(true);
  };

  return (
    <Paper elevation={4} className={classes['select-restaurant-card']}>
      <Box className={classes['card-layout']}>
        <Box className={classes['image-section']}>
          <img src={listImage} alt='Restaurant List Side Header' />
        </Box>

        <Box className={classes['info-section']}>
          <Box className={classes['info-section-layout']}>
            <Box className={classes['info-section-inner-layout']}>
              <Box className={classes['main-info-holder']}>
                <Typography variant='h2' component='h2'>
                  {name}
                </Typography>

                {address ? (
                  <Box className='pb-10'>
                    <Typography>
                      {displayAddress ?? ''}
                    </Typography>
                  </Box>
                ) : null}

                {description ? (
                  <Box className={classes['additional-information-holder']}>
                    <Typography component='pre'>{description}</Typography>
                  </Box>
                ) : null}

                <Box className='pb-3'>
                  <Typography variant='labelInlineSmall'>Food Type: </Typography>
                  <Typography component='span' className='small-text'>{foodType}</Typography>
                </Box>

                <Box className='pb-3'>
                  <Typography variant='labelInlineSmall'>League Experience:</Typography>
                  <Typography component='span' className='small-text'>{leagueExperience}</Typography>
                </Box>

                {displayOrderLeadTime ? (
                  <Box className='pb-3'>
                    <Typography variant='labelInlineSmall'>Order Lead Time:</Typography>
                    <Typography component='span' className='small-text'>{orderLeadTime + ' hours'}</Typography>
                  </Box>
                ) : null}
              </Box>

              <Box className={classes['delivery-info-layout']}>
                <Box>
                  <DeliveryHoursTable deliveryHours={deliveryHours} textSize='small' />
                </Box>

                <Box className='content-right-justified'>
                  <DeliveryFeesSimpleCard deliveryFees={deliveryFees} />
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '10px' }}>
              {rating && numberOfRatings ? (
                <Box onClick={showRestaurantReviewssHandler} sx={{ cursor: 'pointer' }}>
                  <RestaurantRatingWidget rating={rating} numberOfRatings={numberOfRatings} />
                </Box>
              ) : (
                <div></div>
              )}
              <Button
                variant='contained'
                color='accent'
                size='small'
                onClick={() => {
                  selectRestaurant(restaurantUuid, name);
                }}
              >
                Select
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Popup
        openPopup={openPopupReviews}
        setOpenPopup={setOpenPopupReviews}
        title={'Reviews for ' + name}
        maxWidth='md'
      >
        <RestaurantReviewsList propRestaurantUuid={restaurantUuid} mode='popup' />
      </Popup>
    </Paper>
  );
};

export default SelectRestaurantCard;
